import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable } from "ui";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { DeleteBtnCell, DownloadBtnCell } from "./atoms";
import { InventoryBoxesQrsTableProps } from "./InventoryBoxesQrsTable.types";

import styles from "./InventoryBoxesQrsTable.module.scss";

const InventoryBoxesQrsTable = ({
  boxesQrsList,
  sorting,
  setSorting,
  onDeleteQr,
  isLoading
}: InventoryBoxesQrsTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const columns: Array<
    ColumnDef<InventoryBoxQrsListItem, InventoryBoxQrsListItem[]>
  > = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Box name"),
        size: 22,
        minSize: 22,
        cell: ({ row }) => (
          <div className={styles.qrsTable_nameCell}>
            {boxesQrsList[row.index].name ?? "-"}
          </div>
        )
      },
      {
        id: "type",
        accessorKey: "type",
        header: t("Box type"),
        size: 22,
        minSize: 22,
        cell: ({ row }) => <div>{boxesQrsList[row.index].type ?? "-"}</div>
      },
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: t("Created"),
        size: 12,
        minSize: 12,
        cell: ({ row }) => (
          <pre>
            {`${moment(boxesQrsList[row.index].createdAt).format("DD/MM/YYYY")}`}
            {"\n"}
            {`${moment(boxesQrsList[row.index].createdAt).format("HH:mm")}`}
          </pre>
        )
      },

      {
        accessorKey: "downloadBtnColumn",
        header: () => null,
        enableSorting: false,
        size: 15,
        minSize: 15,
        cell: ({ row }) => (
          <DownloadBtnCell boxQrItem={boxesQrsList[row.index]} />
        )
      },

      {
        accessorKey: "DeleteBtnColumn",
        header: () => null,
        size: 3,
        minSize: 3,
        enableSorting: false,
        cell: ({ row }) => (
          <DeleteBtnCell
            boxQrItem={boxesQrsList[row.index]}
            onDeleteClick={onDeleteQr}
          />
        )
      }
    ],
    [boxesQrsList, currentLanguage]
  );

  return (
    <ItemsTable
      className={styles.qrsTable}
      columns={columns}
      data={boxesQrsList}
      sorting={sorting}
      skeletonHeight={60}
      setSorting={setSorting}
      isLoading={isLoading}
    />
  );
};

export default InventoryBoxesQrsTable;
